/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.badgesModule')
.controller('BadgeController', ['$scope', 'BulbModalService', BadgeController]);

/**
 * AngularJS controller for badges.
 */
function BadgeController($scope, BulbModalService) {

  var that = this;
  // Creates a variable that we can use for the rest of our work.
  this.currentBadge = $scope.badgeCtrl.badgeObject;

  // Handles the appearing/disappearing of the title text.
  this.hoverIn = function() {
    this.showTitle = true;
  };

  this.hoverOut = function() {
    this.showTitle = false;
  };

  // Shows the modal on click
  var modalOptions = {
    okButtonCode: 'button_ok',
    templateUrl: 'badgeinfomodal',
    showCancelButton: false,
    windowClass: 'bulb-badge-modal',
    controller: ['$scope', function($scope) {
      $scope.fullBadge = that.currentBadge;
    }]
  };

  this.showBadgeModal = function(event) {
    // This will prevent the Chevron from rotating when the badge modal is opened.
    event.stopPropagation();
    event.preventDefault();

    // Then we show the badge modal with the proper information.
    BulbModalService.show(modalOptions);
  };
}

